import { useMutation } from 'react-query';
import { useService } from '@core/inversify-react';

import { ICloseBoxRepo, CloseBoxRepoType } from '../repos';
import { queryClient } from '../../../index';
import { ValidationError } from '@core/form';

export type UseCloseBoxVariables = { trackCodes: string[]; containerId: string };

export const useCloseBox = () => {
  const closeBoxRepo = useService<ICloseBoxRepo>(CloseBoxRepoType);

  return useMutation<boolean, Error | ValidationError, UseCloseBoxVariables>(
    ['boxes', 'close'],
    async ({ trackCodes, containerId }) => {
      const result = await closeBoxRepo.execute({ trackCodes, containerId });

      if (result.status === 200) {
        return true;
      } else if (result.status === 422) {
        throw new ValidationError('Məlumatlar düzgün daxil edilməyib.', result.response);
      } else {
        throw new Error(result.response);
      }
    },
    {
      onSettled: async () => {
        await queryClient.invalidateQueries(['boxes']);
      },
    },
  );
};
